import { Component, OnInit } from '@angular/core';
import {BooKingservice} from "./booking.service";
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import {Order} from "./order";
import {FoEventsService} from "../event/foevents.service";
import {AuthService} from "../../core/auth/auth.service";

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css'],
  providers :[BooKingservice]
})
export class BookingComponent implements OnInit {
  showSteps :boolean = true;
  stepIndex: number = 0;
  event: any;
  dayname:string;
  day:any;
  month:any;
  hours:any;
  result:Order;
  sessionExpirationTime:number;
  timerMinutes:number =15;
  timerSecondes:number =0;
  currenteventUrl:string;
  inscriptionMode:boolean = false;
  embeded: boolean = false;

  constructor(private bookingservice :BooKingservice, private location: Location, private router: Router, private eventservicce : FoEventsService,private authService:AuthService ) {
     router.events.subscribe((val) => {
        if(val instanceof NavigationEnd)
          if(!this.bookingservice.retrieve('event').hasHousing)
            this.changeStepIndex(val.url);
        else
            this.changeStepIndexWithHousing(val.url);
    });
  }
  slugify(string) {
    return string
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }

  ngOnInit() {
    // TODO #HIGH make a unique booking service and put this method in booking service
  	this.initComponentData();
    console.log(this.bookingservice.retrieve('embeded'));
    if(this.bookingservice.retrieve('embeded')) {
      console.log('ok embeded');
      this.embeded = this.bookingservice.retrieve('embeded');
      console.log(this.embeded);
    } else {
      console.log('not embeded')
    }
  }

  loadDeadlines(id) {
    this.eventservicce.getOrderDeadline(id).then(res => {
      this.event = res.event;
      this.bookingservice.store('deadlines',res.deadlines);
      this.bookingservice.store('paidDeadlines',res.paidDeadlines);
      this.bookingservice.store('nthdeadlines',res.nthdeadlines);
      this.bookingservice.store('order',res.order);
      this.bookingservice.store('event',res.event);
    })
  }


  initComponentData() {
    let url_string = window.location.href;
    if(url_string.indexOf('paymentdealine') >- 1 || this.bookingservice.retrieve('deadlinePayment')) {
      this.showSteps = false;
      let url = new URL(url_string);
      let id = url.searchParams.get("id");
      if(id) {
        this.loadDeadlines(id);
      }
    } else {
      this.loadFromStorage();
      setTimeout(() => {
        let days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        let months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];
        let debut = (this.event.start_date+' '+this.event.start_hour);
        let d = new Date(debut);
        this.dayname = days[d.getDay()];
        this.hours = d.getHours();
        this.day = d.getDate();
        this.month = months[d.getMonth()];
        let me = this;
        setInterval(function () {
          if(me.sessionExpirationTime > 0) {
            me.timerMinutes = me.formatTimer(Math.floor(me.sessionExpirationTime/60000));
            me.timerSecondes = me.formatTimer((me.sessionExpirationTime %60000)/1000);
            me.sessionExpirationTime = me.sessionExpirationTime - 1000;
            me.bookingservice.store('sessionExpirationTime',me.sessionExpirationTime);
          } else {
            /*setTimeout(function () {
              localStorage.clear();
              me.redirectToCurentEvent()

            },30000)*/
          }
        },1000);
      },1000)
    }
  }

  loadFromStorage() {
    this.event = this.bookingservice.retrieve('event');
    this.result = this.bookingservice.retrieve('result');
    this.sessionExpirationTime = this.bookingservice.retrieve('sessionExpirationTime');
    this.currenteventUrl =  this.bookingservice.retrieve('currenteventUrl');
    this.inscriptionMode = this.bookingservice.retrieve('inscriptionIframe');
  }


  formatTimer(item) {
    if(item < 10)
      return '0'+item;
    return item;
  }


  changeStepIndex(url) {
    switch (url) {
      case "/booking/infos":
        this.stepIndex = 1;
        break;
      case "/booking/payment":
        this.stepIndex = 2;
        break;
      case "/booking/payment/success":
        this.stepIndex = 3;
        break;
      default:
        this.stepIndex = 0;
        break;
    }
    if(url.includes('/booking/payment') && !url.includes('booking/payment/success')){
      this.stepIndex = 2;
    }
  }


  changeStepIndexWithHousing(url) {
    switch (url) {
      case "/booking/infos":
        this.stepIndex = 1;
        break;
      case "/booking/housing":
        this.stepIndex = 2;
        break;
      case "/booking/payment":
        this.stepIndex = 3;
        break;

      case "/booking/payment/success":
        this.stepIndex = 4;
        break;
      default:
        this.stepIndex = 0;
        break;
    }
  }


  loggedIn() {
  	return this.authService.hasValidToken();
  }

  redirectToCurentEvent() {
    window.location.href = this.currenteventUrl;
  }

}
